// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const Separator: MarkdocTagRegistration = {
  tag: 'separator',
  component: 'Separator',
  attributes: {
    items: {
      type: Array,
      required: true,
      description: 'List of strings to separate (by default, using a comma)',
    },
    separator: {
      type: String,
      default: ',',
      required: false,
    },
  },
};
